/**
 * Homepage combined events: location chips + day tabs filter schedule cards
 * (recurring weekly play + ticketed events for the current calendar week).
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-homepage-events]').forEach((root) => {
    const locationButtons = root.querySelectorAll('[data-homepage-events-location]');
    const dayButtons = Array.from(root.querySelectorAll('[data-homepage-events-day]'));
    const prevBtn = root.querySelector('[data-homepage-events-day-prev]');
    const nextBtn = root.querySelector('[data-homepage-events-day-next]');
    const weeklyGrid = root.querySelector('[data-homepage-weekly-grid]');
    const weeklyTrack = weeklyGrid?.querySelector('.tavern-drops-row__track');
    const scheduleCards = root.querySelectorAll('[data-homepage-weekly-card]');
    const scheduleEmpty = root.querySelector('[data-homepage-schedule-empty]');

    const weekStartYmd = parseInt(root.dataset.weekStartYmd, 10) || 0;
    const weekEndYmd = parseInt(root.dataset.weekEndYmd, 10) || 0;
    const todayYmd = parseInt(root.dataset.todayYmd, 10) || 0;

    const dayLabels = dayButtons.map((btn) => btn.dataset.dayLabel || btn.textContent.trim());
    let activeLocation =
      root.dataset.defaultLocation ||
      locationButtons[0]?.dataset.homepageEventsLocation ||
      '';
    let activeDayIndex = dayButtons.findIndex((btn) => btn.classList.contains('is-active'));
    if (activeDayIndex < 0) activeDayIndex = 0;

    function normalize(value) {
      return (value || '').toString().trim().toLowerCase();
    }

    function activeDay() {
      return dayButtons[activeDayIndex]?.dataset.homepageEventsDay || '';
    }

    function isTicketedInCurrentWeek(card) {
      const eventDateYmd = parseInt(card.dataset.eventDateYmd, 10);
      if (!eventDateYmd) return true;
      if (!weekStartYmd || !weekEndYmd || !todayYmd) return true;
      return eventDateYmd >= todayYmd && eventDateYmd >= weekStartYmd && eventDateYmd <= weekEndYmd;
    }

    function updateDayLabels() {
      dayButtons.forEach((btn, index) => {
        const isActive = index === activeDayIndex;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');

        const full = btn.querySelector('.homepage-events__day-full');
        const short = btn.querySelector('.homepage-events__day-short');
        const base = btn.dataset.dayLabel || dayLabels[index] || '';

        if (full) {
          full.textContent = isActive ? `${base} Events` : base;
        } else if (!short) {
          btn.textContent = isActive ? `${base} Events` : base;
        }
      });

      if (prevBtn) prevBtn.disabled = activeDayIndex === 0;
      if (nextBtn) nextBtn.disabled = activeDayIndex >= dayButtons.length - 1;
    }

    function applyFilters() {
      const day = activeDay();
      let visibleCount = 0;

      scheduleCards.forEach((card) => {
        const cardLocation = normalize(card.dataset.weeklyLocation);
        const cardDay = normalize(card.dataset.weeklyDay);
        const locationMatch = activeLocation !== '' && cardLocation === activeLocation;
        const dayMatch = !day || cardDay === normalize(day);
        const weekMatch = isTicketedInCurrentWeek(card);
        const show = locationMatch && dayMatch && weekMatch;
        card.classList.toggle('is-hidden', !show);
        if (show) visibleCount += 1;
      });

      if (scheduleEmpty) {
        scheduleEmpty.hidden = visibleCount > 0;
      }
      if (weeklyGrid) {
        weeklyGrid.hidden = visibleCount === 0;
      }
      if (weeklyTrack) {
        weeklyTrack.scrollLeft = 0;
        weeklyTrack.dispatchEvent(new Event('scroll'));
      }
    }

    locationButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        activeLocation = btn.dataset.homepageEventsLocation || '';
        locationButtons.forEach((b) => {
          const pressed = b === btn;
          b.classList.toggle('is-active', pressed);
          b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    dayButtons.forEach((btn, index) => {
      if (!btn.dataset.dayLabel) {
        btn.dataset.dayLabel = btn.textContent.trim();
      }
      btn.addEventListener('click', () => {
        activeDayIndex = index;
        updateDayLabels();
        applyFilters();
      });
    });

    prevBtn?.addEventListener('click', () => {
      if (activeDayIndex > 0) {
        activeDayIndex -= 1;
        updateDayLabels();
        applyFilters();
      }
    });

    nextBtn?.addEventListener('click', () => {
      if (activeDayIndex < dayButtons.length - 1) {
        activeDayIndex += 1;
        updateDayLabels();
        applyFilters();
      }
    });

    updateDayLabels();
    applyFilters();
  });
});
